module.exports = __webpack_public_path__ + "static/img/aaaalobo.17fc2cf7.png";